
































































import settings from "@/settings.coffee"
import mutations from "@/gql/mutations.coffee"
import tools from "@/tools.coffee"
import StateComments from "@/components/StateComments.vue"
import EstablishmentStateComments from '@/components/EstablishmentStateComments'

export default {
    "name": "EstablishmentStateInformationNeeded"
    "components": {StateComments, EstablishmentStateComments}
    "props": {
        "review": Object,
        "establishment": Object,
        "readOnly": false
    },
    "data": ()->
        return {
            "actions": {}
            "state": null
            "show_native_lang_content": false
        }
    "methods":
        "update_data": (comments)->
            @state.data.comments = comments
            serialized = JSON.stringify(@state.data)
            serialized = tools.b64_encode(serialized)
            mutations.run("update_state_data", [@state.uid, serialized])
        "call_action": (slug)->
            self = this
            data = await self.$http.post(settings.graphqlApiUrl, {query: mutations.gql_mutation_state_call_action(self.review.current_state.uid, slug)})
            @$router.push("/")
    "created": ()->
        self = @
        # convert action list to object & keep only establishment ones
        for action in @review.current_state.list_actions
            if "establishment" in action["groups"]
                @actions[action.slug] = action
        @state = @review.current_state
        if @state.data?
            if typeof @state.data == "string"
                @state.data = JSON.parse(@state.data)

        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            if event.obj?
                if event.obj.review == self.review.uid
                    if event.signal_type == "post_save" and event.created == false
                        self.state.data.comments = event.obj.data.comments
                        
        )
        
}
